export const breakpoints = {
  desktop: 1280,
}
